import {Col, Modal, OverlayTrigger, Row, Tooltip} from "react-bootstrap";
import {useNavigate, useSearchParams} from "react-router-dom";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {
  getAgeRangeTypes,
  getCompanyEventMatrixes,
  getEventLocations,
  getInventoryEvent,
  getInventoryEventTypes,
  getInventoryTypes,
  preSaveInventoryEvent,
  saveInventoryEvent
} from "../common/api/InventoryApi";
import {addDate, displayDay, formatCurrency, handleDefaultValues} from "../common/Utils";
import {useForm} from "react-hook-form";
import moment from "moment";
import MDTypography from "../../components/MDTypography";
import MDButton from "../../components/MDButton";
import MDBox from "../../components/MDBox";
import MDInput from "../../components/MDInput";
import {Chip, IconButton, InputAdornment, NativeSelect, TextareaAutosize} from "@mui/material";
import Icon from "@mui/material/Icon";
import Switch from "@mui/material/Switch";
import Loading from "../common/Loading";
import {DateCalendar, DesktopDateTimePicker, DesktopTimePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {CONSTANTS} from "../common/constants";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import {useConfirm} from "../../lib/Confirm";

export default function ManageInventoryEventForm(props) {

  const navigate = useNavigate();
  const statuses = [...CONSTANTS.STATUSES];

  const [party, setParty] = useState(props?.party);
  const [eventLabel, setEventLabel] = useState(props?.party ? 'Party' : 'Event');
  useEffect(() => {
    setParty(props?.party);
    setEventLabel(props?.party ? 'Party' : 'Event');
  }, [props?.party]);

  const dateCalendarStyle = {
    marginLeft: '-20px',
    height: 'auto',
  }

  const {confirm, ConfirmationDialog} = useConfirm();

  const [confirmation, setConfirmation] = useState(null);

  const [removeIndex, setRemoveIndex] = useState(1);
  const [context, setContext] = useContext(AppContext);
  const [eventWarning, setEventWarning] = useState([]);
  const [eventNotice, setEventNotice] = useState([]);
  const [showEventWarning, setShowEventWarning] = useState(false);
  const [showEventNotice, setShowEventNotice] = useState(false);
  const [eventMatrixes, setEventMatrixes] = useState(null);
  const [showMatrix, setShowMatrix] = useState(props?.inventory?.eventMatrix != null || false);
  const [hasMatrix, setHasMatrix] = useState(false);

  const eventWarningCallback = async (e) => {
    setShowEventNotice(false);
    setShowEventWarning(false);
    if (e === 'continue') {
      setSaving(true);
      let result = await handleSaveInventoryEvent(formData);
      let _eventDate = new Date(eventDate);
      if (!result.error) {
        if (props?.handleSave) {
          props.handleSave(result);
        } else {
          if (showEventNotice) {
            navigate('/sales/events' + '?notice=' + result.guid);
          } else {
            navigate('/event/view/' + result.guid + '?initDate=' + _eventDate.toISOString());
          }
        }
      } else {
        setContext({...context, error: {message: result.message}});
        setSaving(false);
      }
    }
  }

  const [newEvent, setNewEvent] = useState(props?.inventory?.guid ? false : true);
  const [price, setPrice] = useState(props?.inventory?.price);
  const [inventoryTypes, setInventoryTypes] = useState([]);
  const [editReady, setEditReady] = useState(props?.inventory?.sessionEvent ? false : true);

  const [eventLocation, setEventLocation] = useState();
  const [eventLocations, setEventLocations] = useState([]);
  const [inventoryEventTypes, setInventoryEventTypes] = useState([]);
  const [ageRangeTypes, setAgeRangeTypes] = useState([]);
  const [inventoryType, setInventoryType] = useState(null);
  const [renderDate, setRenderDate] = useState(new Date().getTime());
  const [manageRecurring, setManageRecurring] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [eventDate, setEventDate] = useState(new Date());
  const [eventEndDate, setEventEndDate] = useState(props.inventory?.eventEndDate || addDate(new Date(), 1));

  const [sessionGuid, setSessionGuid] = useState(props?.inventory?.sessionEvent ? props?.inventory?.parentEventGuid : null);
  const [sessionEvent, setSessionEvent] = useState(false);

  const [eventTemplate, setEventTemplate] = useState(searchParams?.get('template') ? true : false);

  const [templateGuid, setTemplateGuid] = useState(searchParams?.get('fromTemplate') || null);
  const [templateEdit, setTemplateEdit] = useState(false);

  useEffect(() => {
    if (templateGuid) {
      setEditReady(false);
      getInventoryEvent(templateGuid).then((result) => {
        let _event = {...result};
        if (!templateEdit) {
          _event.guid = null;
          _event.eventTemplate = false;
        }
        if (_event?.eventMatrix) {
          setShowMatrix(true);
        }
        setPrice(result?.price);
        setInventory(_event);
        setEditReady(true);
      });
    }
  }, [templateGuid]);

  useEffect(() => {
    if (props?.inventory?.eventTemplate) {
      setEventTemplate(props?.inventory?.eventTemplate);
      if (!templateGuid) {
        setTemplateGuid(props?.inventory?.guid);
        setTemplateEdit(true);
      }
    }
  }, [props?.inventory?.eventTemplate]);

  useEffect(() => {
    if (props?.inventory?.sessionEvent) {
      setSessionEvent(props?.inventory?.sessionEvent);
    }
  }, [props?.inventory?.sessionEvent])

  const [createSessionEventInSeries, setCreateSessionEventInSeries] = useState(props?.inventory?.createSessionEventInSeries);

  useEffect(() => {
    setCreateSessionEventInSeries(props?.inventory?.createSessionEventInSeries);
  }, [props?.inventory]);

  useEffect(() => {
    if (sessionGuid) {
      let _guid = sessionGuid;
      if (props?.inventory?.guid) {
        _guid = props?.inventory?.guid;
      }
      setEditReady(false);
      getInventoryEvent(_guid).then(result => {
        if (result.error) {
          setContext({...context, error: {message: result.message}});
        } else {
          let e = {...result};
          e.parentEventGuid = sessionGuid;
          if (props?.inventory?.createSessionEventInSeries) {
            e.guid = null;
            e.id = null;
          }
          setEditReady(true);
          setInventory({...e});
        }
      });
    }
  }, [sessionGuid]);

  useEffect(() => {
    let _d = new Date();
    let fancyTime = true;
    if (props.inventory?.eventDate) {
      fancyTime = false;
      _d = new Date(props.inventory.eventDate);
    } else if (searchParams?.get('initDate')) {
      let ds = searchParams?.get('initDate').replaceAll('%20', ' ');
      _d = moment(ds, 'YYYY-MM-DD HH:mm Z').toDate();
    }
    if (fancyTime) {
      let m = (Math.round(_d.getMinutes() / 5) * 5) % 60;
      _d.setMinutes(m);
    }

    setEventDate(_d);
    setEventDateTime(_d);
    setEventEndDate(addDate(_d, 1));
  }, []);

  useEffect(() => {
    if (!props) {
      return;
    }
    setManageRecurring(props?.manageRecurring);
  }, [props])

  const [eventDateTime, setEventDateTime] = useState(props.inventory?.eventDate || new Date());
  const [eventDuration, setEventDuration] = useState(props.inventory?.eventDuration || 60);

  useEffect(() => {
    let d = new Date(eventEndDate);
    d.setHours(eventDateTime.getHours());
    d.setMinutes(eventDateTime.getMinutes());
    setEventEndDate(d);

  }, [eventDateTime])

  const [saving, setSaving] = useState(false);
  const [formInvalid, setFormInvalid] = useState(false);

  useEffect(() => {
    if (props?.formSaving) {
      props.formSaving(saving)
    }
  }, [saving]);
  useEffect(() => {
    if (props?.formInvalid) {
      props.formInvalid(formInvalid);
    }
  }, [formInvalid]);

  const [manageInventoryType, setManageInventoryType] = useState(false);

  const [manageInventory, setManageInventory] = useState(false);
  const [inventories, setInventories] = useState(null);
  const [sortInventory, setSortInventory] = useState({field: 'id', direction: 'asc'});
  const [isNew, setIsNew] = useState(!!!props.inventory?.guid);
  const [inventory, setInventory] = useState(props.inventory);

  const [inventoryImage, setInventoryImage] = useState(null);
  const [removeImage, setRemoveImage] = useState(false);
  const [inventoryImageName, setInventoryImageName] = useState(null);
  const [inventoryImageType, setInventoryImageType] = useState(null);
  const [validImageSize, setValidImageSize] = useState(true);
  const [imageSize, setImageSize] = useState(0);

  const [preview, setPreview] = useState(null);

  const [typesReady, setTypesReady] = useState(false);
  const [recurringEvent, setRecurringEvent] = useState(false);

  useEffect(() => {
    if (props?.inventory?.recurringEvent === true) {
      setRecurringEvent(props?.inventory?.recurringEvent || false);
    }
  }, [props?.inventory?.recurringEvent])

  const [allDayEvent, setAllDayEvent] = useState(props.inventory?.allDay || false);

  const initialCronExpression = '0 0 09 ? * MON-FRI *';

  const [cronExpression, setCronExpression] = useState(null);

  const RECURRENCES_DAILY = 1;
  const RECURRENCES_WEEKLY = 2;
  const RECURRENCES_DAYS_OF_MONTH = 3;

  const [recurrenceType, setRecurrenceType] = useState(RECURRENCES_DAILY);
  const [recurrencesDaily, setRecurrencesDaily] = useState(1);
  const [sessionEventOccurrences, setSessionEventOccurrences] = useState(1);
  const [recurrencesGap, setRecurrencesGap] = useState(0);

  const daysInWeek = [
    {id: 1, name: 'Sunday'},
    {id: 2, name: 'Monday'},
    {id: 3, name: 'Tuesday'},
    {id: 4, name: 'Wednesday'},
    {id: 5, name: 'Thursday'},
    {id: 6, name: 'Friday'},
    {id: 7, name: 'Saturday'}
  ];

  const daysInMonth = [];
  for (let i = 1; i <= 31; i++) {
    daysInMonth.push({id: i, name: i});
  }

  useEffect(() => {
    setTypesReady(inventoryTypes?.length && inventoryEventTypes?.length && ageRangeTypes?.length);
  }, [inventoryTypes, inventoryEventTypes, ageRangeTypes]);

  const {register, handleSubmit, setValue, setFocus, control} = useForm({
    values: handleDefaultValues(inventory)
  });

  const [formData, setFormData] = useState();

  const compileCronExpression = (data) => {
    let cronExpression = {
      recurring: recurringEvent,
      sessionEvent: sessionEvent,
      sessionEventOccurrences: sessionEventOccurrences,
      recurrenceType: recurrenceType,
      dayOfWeek: dayOfWeek,
      dayOfMonth: dayOfMonth,
      recurrencesDaily: recurrencesDaily
    }
    return cronExpression;
  }

  const handleSave = async (data) => {

    setSaving(true);

    let d = {...data};

    d.eventTemplate = eventTemplate;
    d.inventoryImage = inventoryImage;
    d.inventoryImageName = inventoryImageName;
    d.inventoryImageType = inventoryImageType;

    if (isNew && !showMatrix && (!price || price <= 0)) {
      let _confirmation = {
        title: 'Event Price',
        message: 'Event Price is empty. Are you sure?'
      };
      setConfirmation(_confirmation);
      const ok = await confirm(_confirmation);
      if (!ok) {
        setConfirmation(null);
        setSaving(false);
        setConfirmation(null);
        setFocus('price')
        return;
      }
    }
    d.price = price;
    if (!showMatrix) {
      d.eventMatrix = null;
    } else {
      d.price = 0;
    }

    let _eventDate = new Date(eventDate);

    _eventDate.setHours(eventDateTime.getHours());
    _eventDate.setMinutes(eventDateTime.getMinutes());
    d.duration = eventDuration;
    d.eventEndDate = eventEndDate;

    d.removeImage = removeImage;
    d.eventDate = _eventDate;
    d.cronExpression = cronExpression;
    d.inventoryEvent = true;
    d.recurrenceType = recurrenceType;
    d.dayOfWeek = dayOfWeek;
    d.dayOfMonth = dayOfMonth;
    d.manageRecurring = manageRecurring;
    let _recurrenceTimes = [];
    d.sessionEvent = sessionEvent;
    d.allDay = allDayEvent;

    for (let i = 0; i < recurrenceTimes.length; i++) {
      let rd = new Date(recurrenceTimes[i]);
      rd.setDate(eventDate.getDate());
      rd.setMonth(eventDate.getMonth());
      rd.setMilliseconds(0);
      rd.setFullYear(eventDate.getFullYear());
      _recurrenceTimes.push(rd);
    }
    d.recurrenceTimes = [..._recurrenceTimes];
    d.timeBlocksEnabled = timeBlocksEnabled;

    if (isNew && d.sessionEvent) {
      let _sessions = [];
      for (let i = 0; i < sessionEventOccurrences; i++) {
        if (i === 0) {
          d.eventDate = sessionTimes[i];
        } else {
          _sessions.push(sessionTimes[i]);
        }
      }
      d.sessionTimes = [..._sessions];
    }

    d.cronExpression = compileCronExpression(d);

    setFormData(d);

    if (newEvent) {
      let preSaveResult = await handlePreSaveInventoryEvent(d);
      let hasConditions = false;
      if (preSaveResult?.warnings?.length > 0) {
        setEventWarning(preSaveResult.warnings);
        setShowEventWarning(true);
        setSaving(false);
        hasConditions = true;
      }
      if (preSaveResult?.notices?.length > 0) {
        setEventNotice(preSaveResult.notices);
        setShowEventNotice(true);
        setSaving(false);
        hasConditions = true;
      }
      if (hasConditions) {
        return;
      }
    }

    let result = await handleSaveInventoryEvent(d);

    if (!result.error) {
      if (props?.handleSave) {
        props.handleSave(result);
      } else {
        navigate('/event/view/' + result.guid + '?initDate=' + _eventDate.toISOString());
      }
    } else {
      setContext({...context, error: {message: result.message}});
      setSaving(false);
    }

  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      setPreview(null);
      setInventoryImageName(null);
      setInventoryImageType(null);
      setInventoryImage(null);
      setValidImageSize(true);
      setImageSize(0);
      return;
    }
    setImageSize(0);
    setInventoryImageName(file.name);
    setInventoryImageType(file.type);
    setValidImageSize(true);

    const reader = new FileReader();

    reader.onload = function (evt) {
      setImageSize(file.size);
      setValidImageSize((file.size / 1e6).toFixed(1) < 5);
      setInventoryImage(btoa(evt.target.result));
    }
    reader.readAsBinaryString(file);

    setPreview(URL.createObjectURL(file));
    setRemoveImage(false);
  }

  const toggleSessionEvent = (e) => {
    setSessionEvent(e.target.checked);
    if (e.target.checked) {
      setRecurringEvent(false);
    }
  };

  const toggleRecurringEvent = (e) => {
    setRecurringEvent(e.target.checked);
    if (e.target.checked) {
      setSessionEvent(false);
    }

    if (!recurringEvent) {
      setCronExpression(null);
    }
  };

  const toggleAllDay = (e) => {
    setAllDayEvent(e.target.checked);
    if (e.target.checked) {
      setEventDuration(0);
    }
  };

  const loadInventoryTypes = () => {
    getInventoryTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setInventoryTypes(result);
      }
    });
  };

  const defaultLocation = {id: -1, name: 'Select Location'};

  const loadEventLocations = () => {
    getEventLocations().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        let _locations = result;
        _locations.unshift(defaultLocation);
        setEventLocations(_locations);
      }
    });
  };

  const loadInventoryEventTypes = () => {
    getInventoryEventTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {

        if (party) {
          let _r = [];
          for (let j in result) {
            if (result[j].specialEvent) {
              _r.push(result[j]);
            }
          }
          setInventoryEventTypes(_r);
        } else {
          setInventoryEventTypes(result);
        }
      }
    });
  }

  const loadAgeRangeTypes = () => {
    getAgeRangeTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setAgeRangeTypes(result);
      }
    });
  }

  const handlePreSaveInventoryEvent = async (inventory) => {
    let result = await preSaveInventoryEvent(inventory);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    }
    return result;
  }

  const handleSaveInventoryEvent = async (inventory) => {
    let result = await saveInventoryEvent(inventory);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      let c = {...context}
      c.toast = {message: eventLabel + ' Saved Successfully', type: 'success'};
      setContext(c);
      if (props?.handleClose) {
        props.handleClose();
      }
    }

    return result;
  }

  const handleCloseInventory = () => {
    setManageInventory(false);
  }

  const loadCompanyMatrixes = () => {
    getCompanyEventMatrixes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setEventMatrixes(result);
        if (result?.length > 0) {
          setHasMatrix(true);
        }
      }
    });
  }

  useEffect(() => {
    // get inventory types
    loadInventoryTypes();
    loadInventoryEventTypes();
    loadAgeRangeTypes();
    loadEventLocations();
    loadCompanyMatrixes();
  }, []);

  const updateEventDates = (date) => {
    setEventDate(date);
    setEventEndDate(addDate(date, 1));
  }

  const [dayOfWeek, setDayOfWeek] = useState([]);
  const [dayOfMonth, setDayOfMonth] = useState([]);

  const handleWeekdayChange = (e) => {
    let _days = [...dayOfWeek];
    if (e.target.checked) {
      _days = [..._days, parseInt(e.target.value, 10)];
    } else {
      _days.splice(dayOfWeek.indexOf(parseInt(e.target.value, 10)), 1);
    }
    setDayOfWeek(_days);
  };

  const handleMonthdayChange = (e) => {
    let _days = [...dayOfMonth];
    if (e.target.checked) {
      _days = [..._days, parseInt(e.target.value, 10)];
    } else {
      _days.splice(dayOfMonth.indexOf(parseInt(e.target.value, 10)), 1);
    }
    setDayOfMonth(_days);
  };

  const recurringStyle = {
    'width': '340px',
  }

  const toggleDeposit = (e) => {
    let _inventory = {...inventory};
    _inventory.paymentDeposit = e.target.checked;
    if (!e.target.checked) {
      _inventory.depositPercent = 0;
    }
    setInventory(_inventory);
  }

  const [recurrenceTimes, setRecurrenceTimes] = useState([]);
  const [sessionTimes, setSessionTimes] = useState([]);

  const getRecurrenceTime = (idx) => {
    if (!recurrenceTimes[idx]) {
      let _recurrenceTimes = [...recurrenceTimes];
      let _d = eventDate ? new Date(eventDate) : new Date();
      _d.setTime(_d.getTime() + (eventDuration * 60 * 1000 * idx))
      _recurrenceTimes[idx] = _d;
      setRecurrenceTimes(_recurrenceTimes);
      return _recurrenceTimes[idx];
    }
    return recurrenceTimes[idx];
  }

  const getSessionTime = (idx) => {
    if (!sessionTimes[idx]) {
      let _sessionTimes = [...sessionTimes];
      _sessionTimes[idx] = new Date();
      setSessionTimes(_sessionTimes);
      return _sessionTimes[idx];
    }
    return sessionTimes[idx];
  }

  useEffect(() => {
    if (recurrenceTimes?.length > recurrencesDaily) {
      let _recurrenceTimes = [...recurrenceTimes];
      let _rr = [];
      for (let j = 0; j < recurrencesDaily - 1; j++) {
        _rr.push(_recurrenceTimes[j]);
      }
      setRecurrenceTimes(_rr);
    }
  }, [recurrencesDaily]);

  const updateRecurrenceTimes = (eventDateTime, idx) => {
    let _times = [...recurrenceTimes];
    _times[idx] = eventDateTime;
    setRecurrenceTimes(_times);
    setRenderIdx(renderIdx + 1);
  }

  const updateSessionTimes = (eventDateTime, idx) => {
    let _times = [...sessionTimes];
    _times[idx] = eventDateTime;
    setSessionTimes(_times);
    setRenderIdx(renderIdx + 1);
  }

  const [selectedCategory, setSelectedCategory] = useState();

  const categoryChange = (categoryId) => {
    let showDepositHelp = false;
    let showMemberOnlyHelp = false;

    for (let j in inventoryEventTypes) {
      if (parseInt(inventoryEventTypes[j].id, 10) === parseInt(categoryId, 10)) {
        showDepositHelp = inventoryEventTypes[j].initialDeposit;
        showMemberOnlyHelp = inventoryEventTypes[j].memberOnly;
        setSelectedCategory(inventoryEventTypes[j]);
      }
    }
    setDepositEventType(showDepositHelp);
    setMemberOnlyEventType(showMemberOnlyHelp);
  }

  const [depositEventType, setDepositEventType] = useState(false);
  const [memberOnlyEventType, setMemberOnlyEventType] = useState(false);

  const eventLabels = (idx) => {
    if (idx === 0) {
      return 'first';
    }
    if (idx === 1) {
      return 'second';
    }
    if (idx === 2) {
      return 'third';
    }
    if (idx === 3) {
      return 'fourth';
    }
    if (idx === 4) {
      return 'fifth';
    }
    if (idx === 5) {
      return 'sixth';
    }
    if (idx === 6) {
      return 'seventh';
    }
    if (idx === 7) {
      return 'eighth';
    }
    if (idx === 8) {
      return 'ninth';
    }
    if (idx === 9) {
      return 'tenth';
    }
    return 'event ' + (idx + 1);
  }

  const recurrenceTimePicker = (idx) => {
    return (<div key={idx} className={'d-block my-2'}>
      <DesktopTimePicker
        label="Event Time"
        value={dayjs(getRecurrenceTime(idx))}
        onChange={(newValue) =>
          updateRecurrenceTimes(newValue.$d, idx)
        }
      />
    </div>)
  }

  const sessionDateTimePicker = (idx) => {
    return (<div key={idx} className={'d-block mb-2'}>
      <label>Choose time for {eventLabels(idx)} session event</label>
      <br/>
      <DesktopDateTimePicker
        value={dayjs(getSessionTime(idx))}
        onChange={(e, v) => {
          updateSessionTimes(e.$d, idx)
        }}
      />
    </div>)
  }

  const handleLocationChange = (e) => {
    setEventLocation(e.target.value);
  }

  const handleInventoryTypeChange = (e) => {
    setInventoryType(e.target.value);
  }

  const [renderIdx, setRenderIdx] = useState(1);

  const renderOccurrencesInput = () => {
    let inputs = [];
    for (let i = 0; i < recurrencesDaily; i++) {
      inputs.push(recurrenceTimePicker(i));
    }
    return inputs;
  }

  const renderSessionsInput = () => {
    let inputs = [];
    for (let i = 0; i < sessionEventOccurrences; i++) {
      inputs.push(sessionDateTimePicker(i));
    }
    return inputs;
  }

  const removePreviewImage = () => {
    setRemoveImage(true);
    setImageSize(0);
    setInventoryImage(null);
    setValidImageSize(true);
    setPreview(null);
  }

  const [timeBlocksEnabled, setTimeBlocksEnabled] = useState(false);
  const [showManageTimeBlocks, setShowManageTimeBlocks] = useState(false);
  const toggleTimeBlocksEnabled = () => {
    setTimeBlocksEnabled(!timeBlocksEnabled);
  }

  return (

    <>
      {!editReady && <Loading/>}
      {editReady && <form
        onSubmit={handleSubmit(handleSave)} id={'manageInventoryEventForm'}>

        {sessionEvent && !createSessionEventInSeries &&
          <MDBox className={'px-4'}>
            <MDTypography variant="p" color="primary" fontWeight="regular">
              <Icon>event_repeat</Icon> You are managing a session event
            </MDTypography>
          </MDBox>
        }
        <Grid container spacing={2} direction="row-reverse" className={'p-4'}>

          <Grid item xs={12} sm={12}>
            <Row>
              <Col className={'d-block'}>
                <Row className={'mb-4'}>
                  <MDTypography variant={'h5'} fontWeight={'light'} style={{
                    marginBottom: '20px'
                  }}>
                    {party ? 'Party Details' : 'Event Details'}
                  </MDTypography>
                  <Col className={'col'} md={6} sm={12}>
                    <div className="form-group">
                      <MDInput type="text" required
                               {...register('name')}
                               autoComplete="off"
                               InputLabelProps={{shrink: true}}
                               className="form-control" id="name"
                               label={eventLabel + ' Name'}
                               placeholder={'Enter ' + eventLabel + ' Name'}/>
                    </div>
                  </Col>
                  <Col className={'col'} md={6} sm={12}>
                    <div className="form-group native-margin-fix">
                      <label htmlFor="status" className={"native-label"}>Status</label>
                      {statuses?.length && <NativeSelect
                        variant="outlined"
                        required
                        id={'status'} name={'status'} className={'form-control'}
                        {...register('status.id', {
                          valueAsNumber: true
                        })} >
                        {
                          statuses?.map((c) =>
                            <option value={c.id} key={c.id}>
                              {c.name}
                            </option>)
                        }
                      </NativeSelect>}
                    </div>
                  </Col>
                </Row>
                <Row className={'mb-4'}>
                  <Col className={'col'} md={6} sm={12}>
                    <div className="form-group">
                      <div className={'input-group'}>
                        {memberOnlyEventType &&
                          <MDInput type="text" step="0.01" required
                                   disabled={createSessionEventInSeries || memberOnlyEventType}
                                   defaultValue={'0.00'}
                                   autoComplete="off"
                                   InputLabelProps={{shrink: true}}
                                   InputProps={{
                                     readOnly: true,
                                     startAdornment: <span className={'fa fa-dollar'}></span>
                                   }}
                                   name={'price'}
                                   className="form-control" id="price"
                                   label={sessionEvent ? 'Session Price' : 'Price'}
                                   placeholder="Price"/>
                        }

                        {!memberOnlyEventType && <>

                          {showMatrix && <>
                            <div className="form-group native-margin-fix" style={{
                              width: '100%',
                              marginTop: '-27px'
                            }}>
                              <label htmlFor="ageRange" className={"native-label"}>Event Price Matrix *</label>
                              <Grid container>
                                <Grid item xs={11}>
                                  {eventMatrixes?.length > 0 && <NativeSelect
                                    sx={{
                                      clear: 'both',
                                      display: 'block',
                                    }}
                                    required
                                    variant="outlined"
                                    disabled={createSessionEventInSeries}
                                    id={'eventMatrix'} name={'eventMatrix'} className={'form-control'}
                                    {...register('eventMatrix.id', {
                                      valueAsNumber: true,
                                      required: true,
                                      min: 1,
                                    })} defaultValue={-1}>
                                    <option value={-1}>
                                      Select Event Price Matrix
                                    </option>
                                    {
                                      eventMatrixes
                                        .sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1)
                                        .map((c) =>
                                          <option value={c.id} key={c.id}>
                                            {c.name}
                                          </option>)
                                    }
                                  </NativeSelect>}
                                </Grid>
                                <Grid item xs={1} justifyContent="flex-end" alignItems="flex-end"
                                      sx={{position: 'relative', border: 'solid 1px #ddd'}}>
                                  <MDButton
                                    onClick={() => {
                                      setShowMatrix(false);
                                    }}
                                    style={{
                                      width: '98%',
                                      height: '98%',
                                    }}
                                    iconOnly
                                  >
                                    <Icon>grid_on</Icon>
                                  </MDButton>
                                </Grid>
                              </Grid>

                            </div>

                          </>}


                          {!showMatrix && <MDInput type="text" step="0.01" required
                                                   {...register('price', {
                                                     valueAsDouble: true,
                                                     onChange: (e) => {
                                                       let v = e.target.value.replace(/[^0-9.]/g, '');
                                                       e.target.value = v;
                                                       setPrice(v)
                                                     }
                                                   })}
                                                   InputProps={{
                                                     startAdornment: <span className={'fa fa-dollar'}></span>,
                                                     endAdornment: <InputAdornment style={{
                                                       display: hasMatrix ? 'block' : 'none',
                                                       cursor: 'pointer',
                                                       height: '100%',
                                                       margin: '-10px 0',
                                                       padding: '5px 5px 5px 15px',
                                                       borderLeft: 'solid 1px #ddd',
                                                     }} position="end" onClick={(e) => {
                                                       setShowMatrix(!showMatrix);
                                                     }}>
                                                       {showMatrix ? <Icon>grid_on</Icon> :
                                                         <Icon>grid_off</Icon>}
                                                     </InputAdornment>
                                                   }}
                                                   InputLabelProps={{shrink: true}}
                                                   disabled={createSessionEventInSeries || memberOnlyEventType}
                                                   defaultValue={'0.00'}
                                                   autoComplete="off"
                                                   name={'price'}
                                                   className="form-control" id="price"
                                                   label="Price"
                                                   placeholder="Price"/>}

                        </>
                        }

                      </div>

                    </div>
                  </Col>

                  <Col className={'col'} md={6} sm={12}>
                    <div className="form-group">
                      <MDInput type="number" required
                               {...register('totalAvailable', {
                                 valueAsNumber: true,
                               })}
                               InputLabelProps={{shrink: true}}
                               label={party ? "Max Attendees" : "Attendee Event Size"}
                               defaultValue={0}
                               autoComplete="off"
                               className="form-control" id="totalAvailable"
                      />
                    </div>
                  </Col>

                </Row>

                <Row className={'mt-2'}>

                  <Col className={'col'} md={6} sm={12}>
                    <div className="form-group native-margin-fix">
                      <label htmlFor="eventLocation" className={"native-label"}>{eventLabel} Location</label>
                      {eventLocations?.length > 0 && <NativeSelect
                        variant="outlined"
                        id={'eventLocation'} name={'eventLocation'} className={'form-control'}
                        {...register('eventLocation.id', {
                          valueAsNumber: true,
                          onChange: handleLocationChange
                        })} >
                        {
                          eventLocations.sort((a, b) => a.id - b.id).map((c) =>
                            <option value={c.id} key={c.id}>
                              {c.name}
                            </option>)
                        }
                      </NativeSelect>}
                    </div>
                  </Col>

                  <Col className={'col'} md={6} sm={12}>
                    <div className="form-group native-margin-fix">
                      <label htmlFor="inventoryType" className={"native-label"}>Inventory Type *</label>
                      {inventoryTypes?.length > 0 && <NativeSelect
                        required
                        variant="outlined"
                        disabled={createSessionEventInSeries}
                        id={'inventoryType'} name={'inventoryType'} className={'form-control'}
                        {...register('inventoryType.id', {
                          valueAsNumber: true,
                          required: true,
                          min: 1,
                          onChange: handleInventoryTypeChange
                        })} >
                        <option value={-1}>
                          Select Inventory Type
                        </option>
                        {inventoryTypes.map((c) =>
                          <option value={c.id} key={c.id}>
                            {c.name}
                          </option>)
                        }
                      </NativeSelect>}
                    </div>
                  </Col>
                </Row>


                <Row>
                  <Col className={'col '} md={6} sm={12}>

                    <div className="form-group mt-2 native-margin-fix">
                      <label htmlFor="eventType" className={"native-label"}>{eventLabel} Type *</label>
                      {inventoryEventTypes?.length > 0 && <NativeSelect
                        required
                        variant="outlined"
                        disabled={createSessionEventInSeries}
                        id={'eventType'} name={'eventType'}
                        className={'form-control'}
                        {...register('eventType.id', {
                          valueAsNumber: true,
                          required: true,
                          min: 1,
                          onChange: (e) => {
                            categoryChange(e.target.value)
                          }
                        })} >
                        <option value={-1}>
                          Select Event Type
                        </option>

                        {inventoryEventTypes.map((c) =>
                          <option value={c.id} key={c.id}>
                            {c.name}
                          </option>)
                        }

                      </NativeSelect>}
                    </div>
                  </Col>
                  <Col className={'col'} md={6} sm={12}>
                    <div className="form-group mt-2 native-margin-fix">
                      <label htmlFor="ageRange" className={"native-label"}>Age Range</label>
                      {ageRangeTypes?.length > 0 && <NativeSelect
                        variant="outlined"
                        disabled={createSessionEventInSeries}
                        id={'ageRange'} name={'ageRange'} className={'form-control'}
                        {...register('ageRange.id', {
                          valueAsNumber: true,
                        })} defaultValue={-1}>
                        {
                          ageRangeTypes
                            .sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1)
                            .map((c) =>
                              <option value={c.id} key={c.id}>
                                {c.name}
                              </option>)
                        }
                      </NativeSelect>}
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col className={'col'} md={12}>
                    <div>
                      {(selectedCategory?.siblingOptionsEnabled || selectedCategory?.infantOptionsEnabled) &&
                        <div className={'py-2'}><span className={'fw-light'}>Sibling Options</span><br/>
                          {selectedCategory?.siblingOptionsEnabled &&
                            <Chip variant="outlined"
                                  label={'Sibling Discount ' + formatCurrency(selectedCategory?.siblingDiscount)}
                            />
                          }
                          {selectedCategory?.infantOptionsEnabled &&
                            <Chip variant="outlined"
                                  label={'Free Infant ' + selectedCategory.infantDiscountAge + ' mos'}
                            />
                          }
                        </div>
                      }

                      {selectedCategory?.linkedAccountTypes?.length > 0 && <>
                        <div className={'py-2'}><span className={'fw-light'}>Linked Account Types</span><br/>
                          {selectedCategory?.linkedAccountTypes?.map((a, idx) => {
                            return (<span key={idx}>
                        <Chip label={a}
                              className={'mb-1'}
                              variant="outlined"
                        />&nbsp;
                      </span>)
                          })
                          }
                        </div>
                      </>}
                      {memberOnlyEventType &&
                        <p className={'py-2 fw-light'}>Note: This Event Type is Member Only.
                          Pricing for Event is disabled as member only events cannot be purchased directly.</p>}
                      {depositEventType &&
                        <p className={'py-2 fw-light'}>Note: This Event Type accepts an initial deposit.
                          Sale Price will be divided by Deposit percentage and an invoice will be generated for
                          the remaining balance.</p>}

                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col className={'col mt-4'} md={6} sm={12}>
                    <div className="form-group">
                      <label htmlFor="inventoryImage">{eventLabel} Image</label>
                      <input type="file"
                             accept="image/*"
                             {...register('inventoryImage', {
                               onChange: (e) => {
                                 handleFileChange(e);
                               }
                             })}
                             autoComplete="off"
                             className="form-control" id="inventoryImage"/>
                      <div className={"clear clearfix"}>
                        <p className={!validImageSize ? 'pt-2 text-danger' : 'pt-2 fw-light'}>Maximum image size 5Mb
                          {!validImageSize ? ' Exceeded' : ''}</p>
                      </div>

                      {preview && <><img className={'img-thumbnail'} src={preview} alt="img"/>
                        <div>
                          <Chip label="Remove"
                                style={{
                                  background: '#fff'
                                }}
                                className={'cls clear-both remove-button cursor-default'}
                                variant="outlined" onClick={() => {
                            setInventoryImage(null);
                            setValidImageSize(true);
                            removePreviewImage();
                          }}/>
                        </div>
                      </>}

                      {!preview && inventory?.imageUrl && removeIndex > 0 &&
                        <><img className={'img-thumbnail'} src={inventory.imageUrl} alt="img"/>
                          <div>
                            <Chip label="Remove"
                                  style={{
                                    background: '#fff'
                                  }}
                                  className={'cls clear-both remove-button cursor-default'}
                                  variant="outlined" onClick={() => {
                              setInventoryImage(null);
                              setValidImageSize(true);
                              setRemoveIndex(0);

                              removePreviewImage();
                            }}/>
                          </div>
                        </>}
                    </div>

                  </Col>
                </Row>

                <Row className={'mb-4'}>
                  <Divider/>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group native-margin-fix">
                      <label htmlFor="name" className={"native-label"}>{eventLabel} Description</label>
                      <TextareaAutosize
                        {...register('desc')}
                        autoComplete="off"
                        maxLength={4000}
                        minRows={3}
                        className="form-control" id="desc"
                        placeholder={'Enter ' + eventLabel + ' Description'}/>
                    </div>
                  </Col>
                  <Divider/>
                </Row>

                {!eventTemplate && newEvent &&
                  <Row className={'mt-2'}>
                    <Grid item xs={12}>
                      <MDTypography variant={'h5'} fontWeight={'light'} style={{
                        marginBottom: '20px'
                      }}>
                        {party ? 'Party Date' : 'Event Date and recurrence'}
                      </MDTypography>
                    </Grid>
                    <Col className={'col'} md={6} sm={12}>
                      <div className={'d-block my-2'}>
                        <label className={'form-check-label cursor-pointer'} htmlFor="recurringEvent">
                          <Switch
                            // disabled={sessionEvent}
                            style={{marginRight: '5px'}}
                            role={'switch'}
                            checked={recurringEvent}
                            {...register('recurringEvent',
                              {
                                onChange: (e) => {
                                  toggleRecurringEvent(e);
                                }
                              })}
                            id="recurringEvent"/>
                          &nbsp;Repeat Event
                        </label>
                        <p className={'py-2 fw-light'}>
                          Create multiple occurrences on a schedule.
                        </p>
                      </div>
                    </Col>


                    <Col className={'col'} md={6} sm={12}>

                      {!party &&
                        <>
                          <div className={'d-block my-2'}>
                            <label className={'form-check-label cursor-pointer'} htmlFor="sessionEvent">
                              <Switch
                                style={{marginRight: '5px'}}
                                role={'switch'}
                                checked={sessionEvent}
                                disabled={createSessionEventInSeries}
                                {...register('sessionEventToggle',
                                  {
                                    onChange: (e) => {
                                      toggleSessionEvent(e);
                                    }
                                  })}
                                id="sessionEvent"/>
                              &nbsp;Session Event
                            </label>
                          </div>
                          <p className={'py-2 fw-light'}>
                            Session events occur in groups, such as a series of classes or a clinic.
                          </p>
                        </>
                      }

                    </Col>
                  </Row>
                }

                {!manageRecurring &&
                  <Grid container spacing={2}>
                    {!(!sessionEvent || createSessionEventInSeries) && <>

                      <Grid item xs={12} sm={6}>
                        &nbsp;
                      </Grid>
                    </>
                    }
                    {(!sessionEvent || createSessionEventInSeries) && <>
                      <Grid item xs={12} sm={4}>
                        {!eventTemplate && <>
                          <label htmlFor={'eventEndDate'}>
                            <MDTypography variant="h6" fontWeight="regular">
                              Initial {party ? 'Party' : 'Event'}&nbsp;Date
                            </MDTypography>
                          </label>
                          <DateCalendar
                            sx={dateCalendarStyle}
                            views={['day', 'month']}
                            value={dayjs(eventDate)}
                            onChange={(e, v) => {
                              setEventDate(e.$d)
                            }}
                          />

                          {(!newEvent || (!recurringEvent && !sessionEvent)) &&
                            <>
                              <DesktopTimePicker
                                label="Event Time"
                                value={dayjs(eventDateTime)}
                                onChange={(newValue) =>
                                  setEventDateTime(newValue.$d)
                                }
                              />
                            </>
                          }
                        </>
                        }
                        {!party && <div className={sessionEvent ? 'd-block' : 'd-block my-2'}>
                          <label className={'form-check-label cursor-pointer'} htmlFor="allDay">
                            <Switch
                              style={{marginRight: '5px'}}
                              role={'switch'}
                              defaultChecked={props?.inventory?.allDay}
                              {...register('allDayToggle',
                                {
                                  onChange: (e) => {
                                    toggleAllDay(e);
                                  }
                                })}
                              id="allDay"/>
                            &nbsp;All Day
                          </label>
                        </div>}
                        <span className={'d-block my-4 ' + (allDayEvent ? 'd-none' : '')}>
                        <MDInput type="number" required
                                 {...register('eventDuration', {
                                   valueAsNumber: true,
                                 })}
                                 disabled={allDayEvent}
                                 min={1}
                                 InputLabelProps={{shrink: true}}
                                 label={"Event Duration"}
                                 defaultValue={60}
                                 autoComplete="off"
                                 className="form-control" id="eventDuration"
                        />
                          <p className={'py-2 fw-light'}>
                            Length of {eventLabel} in minutes
                          </p>
                        </span>
                      </Grid>
                    </>
                    }

                    {newEvent && recurringEvent &&
                      <>
                        <Grid item xs={12} sm={4}>
                          <div className="form-group">
                            <label htmlFor={'eventEndDate'}>
                              <MDTypography variant="h6" fontWeight="regular">
                                Last {party ? 'Party' : 'Event'} Date in Series
                              </MDTypography>
                            </label>
                            <DateCalendar
                              sx={dateCalendarStyle}
                              views={['day', 'month']}
                              value={dayjs(eventEndDate)}
                              onChange={(e, v) => {
                                setEventEndDate(e.$d)
                              }}
                            />
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <MDTypography variant="h6" fontWeight="regular" style={{
                            marginBottom: '15px',
                          }}>
                            Repeat event options
                          </MDTypography>
                          <label className={'d-block'}>
                            <input type={'radio'}
                                   defaultChecked={recurrenceType === RECURRENCES_DAILY}
                                   name={'recurrenceType'}
                                   value={RECURRENCES_DAILY}
                                   onChange={(e) => {
                                     setRecurrenceType(RECURRENCES_DAILY);
                                   }}
                            /> Repeat Daily</label>

                          <label className={'d-block'}>
                            <input type={'radio'}
                                   defaultChecked={recurrenceType === RECURRENCES_WEEKLY}
                                   name={'recurrenceType'}
                                   value={RECURRENCES_WEEKLY}
                                   onChange={(e) => {
                                     setRecurrenceType(RECURRENCES_WEEKLY);
                                   }}/> Repeat Weekly
                          </label>
                          <label className={'d-block'}>
                            <input type={'radio'}
                                   defaultChecked={recurrenceType === RECURRENCES_DAYS_OF_MONTH}
                                   name={'recurrenceType'}
                                   value={RECURRENCES_DAYS_OF_MONTH}
                                   onChange={(e) => {
                                     setRecurrenceType(RECURRENCES_DAYS_OF_MONTH);
                                   }}
                            /> Repeat Monthly
                          </label>

                          {recurrenceType &&
                            <>
                              <Divider/>
                              <label htmlFor={'recurrencesDaily'}>Events per day</label>
                              <input type="number"
                                     required
                                     min="1"
                                     autoComplete="off"
                                     className={'form-control'}
                                     defaultValue={recurrencesDaily}
                                     placeholder={'Events per day'}
                                     {...register('recurrencesDaily',
                                       {
                                         valueAsNumber: true,
                                         onChange: (e) => {
                                           setRecurrencesDaily(e.target.value);
                                         }
                                       })}
                                     id="recurrencesDaily"/>
                              <p className={'mt-2 fw-medium'}>
                                Event occurrences per day, choose times of event(s) below
                              </p>

                              {recurrencesDaily > 0 && <>
                                {renderIdx &&
                                  <>
                                    {renderOccurrencesInput()}
                                  </>
                                }
                              </>
                              }


                              <div>
                                <label
                                  htmlFor="rangeReport">
                                  <Switch
                                    name={'rangeReport'}
                                    id={'rangeReport'}
                                    checked={timeBlocksEnabled}
                                    style={{marginRight: '5px'}}
                                    onChange={toggleTimeBlocksEnabled}
                                  /> Display as single grouped event
                                  <OverlayTrigger
                                    placement={'left'}
                                    delay={{show: 250, hide: 400}}
                                    overlay={
                                      <Tooltip title={"help"} className={'tooltip-wide'}>
                                        <div style={{
                                          textAlign: 'left',
                                        }}>
                                          <h6>Default</h6>
                                          <p>
                                            Each scheduled time appears as its own event on the calendar.
                                          </p><p>
                                          Example:
                                        </p><p>
                                          Open Play — 9:00 AM<br/>
                                          Open Play — 11:00 AM<br/>
                                          Open Play — 2:00 PM<br/>
                                        </p><p>
                                          Each time is displayed as a separate calendar block and can be selected
                                          individually.
                                        </p>
                                          <h6>Display as single grouped event</h6>
                                          <p>
                                            All scheduled times are grouped under one event on the calendar.
                                          </p><p>
                                          Example:
                                        </p><p>
                                          Open Play
                                          9:00 AM, 11:00 AM, 2:00 PM
                                        </p><p>
                                          The calendar shows the event name once with all available times. Selecting a
                                          specific time lets you view the details for that occurrence.
                                        </p>
                                        </div>
                                      </Tooltip>
                                    }>
                                    <IconButton size={'small'}>
                                      <Icon>help</Icon>
                                    </IconButton>
                                  </OverlayTrigger>
                                </label>
                              </div>
                              <p className={'py-2 fw-light'}>
                                A grouped event will display as a single event on the calendar with multiple time
                                options.
                              </p>
                              <Divider/>

                            </>
                          }
                          {recurrenceType === RECURRENCES_WEEKLY && <>
                            <Divider/>
                            <p className={'py-2 fw-light'}>
                              Choose day(s) of week for event to repeat.
                            </p>
                            {daysInWeek.map((day) =>
                                <span className={'d-block'} key={'weekDay-' + day.id}>
                              <label htmlFor={day.id}><input type={'checkbox'}
                                                             checked={dayOfWeek.includes(parseInt(day.id, 10))}
                                                             id={day.id} value={day.id} onChange={(e) => {
                                handleWeekdayChange(e);
                              }}/> &nbsp;{day.name}</label>
                            </span>
                            )}
                          </>}

                          {recurrenceType === RECURRENCES_DAYS_OF_MONTH && <span className={'my-n2'}>
                    <p className={'mt-2 fw-medium'}>
                              Schedule days(s) of month to repeat event
                            </p>
                            {daysInMonth.map((day, idx) =>
                                <span key={idx}>
                          <span className={'d-inline p-1'} key={'monthDay-' + day.id}>
                            <label htmlFor={day.id}><input type={'checkbox'}
                                                           checked={dayOfMonth.includes(parseInt(day.id, 10))}
                                                           id={day.id} value={day.id} onChange={(e) => {
                              handleMonthdayChange(e);
                            }}/> &nbsp;{day.name}</label>
                          </span>
                                  {(day.id) % 5 === 0 && <br/>}
                        </span>
                            )}
                      </span>}
                        </Grid>
                      </>

                    }

                    {newEvent && !createSessionEventInSeries && sessionEvent &&
                      <><Grid item xs={12} sm={4}>

                        <span className={'d-block my-4 ' + (allDayEvent ? 'd-none' : '')}>
                        <MDInput type="number" required
                                 {...register('eventDuration', {
                                   valueAsNumber: true,
                                 })}
                                 disabled={allDayEvent}
                                 min={1}
                                 InputLabelProps={{shrink: true}}
                                 label={"Event Duration"}
                                 defaultValue={60}
                                 autoComplete="off"
                                 className="form-control" id="eventDuration"
                        />
                          <p className={'py-2 fw-light'}>
                            Length of {eventLabel} in minutes
                          </p>
                        </span>

                        <label htmlFor={'sessionEventTimes'}>Number of Events in Session</label>
                        <input type="number"
                               required
                               autoComplete="off"
                               className={'form-control'}
                               min="1"
                               defaultValue={sessionEventOccurrences}
                               placeholder={'Session events'}
                               {...register('sessionEventOccurrences',
                                 {
                                   valueAsNumber: true,
                                   onChange: (e) => {
                                     setSessionEventOccurrences(e.target.value);
                                   }
                                 })}
                               id="sessionEventTimes"/>
                        <div className={'mt-4'}>
                          {sessionEvent && sessionEventOccurrences > 0 && <>
                            {renderIdx &&
                              <>
                                {renderSessionsInput()}
                              </>
                            }
                          </>
                          }
                        </div>
                      </Grid>
                      </>
                    }
                  </Grid>
                }
              </Col>
            </Row>
          </Grid>
        </Grid>
        <Grid>
          <Row>
            <Col>
              {!props.embedded && <Row className={'mt-2'}>
                <Col className={'col'} sm={12} xs={12}>
                  <MDButton className={'pull-right'}
                            type="submit"
                            variant="gradient"
                            color="info"
                            disabled={formInvalid || saving || !validImageSize}>
                    {saving ? 'Saving...' : 'Save'}
                  </MDButton>
                </Col>
              </Row>}
            </Col>
          </Row>
        </Grid>
      </form>
      }

      {confirmation && <ConfirmationDialog/>}

      <Modal show={showEventWarning || showEventNotice} size="lg" onHide={eventWarningCallback}>
        <Modal.Header closeButton>
          <Modal.Title>Notice</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          {showEventNotice && <>
            <MDTypography variant="h5" color="secondary" fontWeight="regular" my={1}>
              Mass Save Notification
            </MDTypography>
            <MDTypography variant="p" color="secondary" fontWeight="regular" my={1} mb={2}>
              You are about to create a large series of events.
            </MDTypography>
            <table className="table table-striped">
              <thead>
              <tr>
                <th scope="col">Notice</th>
                <th scope="col" className="text-left">Message</th>
              </tr>
              </thead>
              <tbody>
              {eventNotice.map((event, key) => (
                <tr key={key}>
                  <td>{event.type}</td>
                  <td>{event.message}</td>
                </tr>
              ))}
              </tbody>
            </table>
          </>}

          {showEventWarning && <>
            <MDTypography variant="h5" color="secondary" fontWeight="regular" my={1}>
              Conflicting events found
            </MDTypography>
            <MDTypography variant="p" color="secondary" fontWeight="regular" my={1} mb={2}>
              We found events that conflict with the time and location of your current event.
            </MDTypography>
            <table className="table table-striped">
              <thead>
              <tr>
                <th scope="col">Event Name</th>
                <th scope="col" className="text-right">Event Date</th>
                <th scope="col" className="text-right">View</th>
              </tr>
              </thead>
              <tbody>

              {eventWarning.sort((a, b) => new Date(a.eventDate).getTime() - new Date(b.eventDate).getTime())
                .map((event, key) => (
                  <tr key={key}>
                    <td>{event.name}</td>
                    <td className="text-right">{displayDay(event.eventDate, 'MM/DD/YYYY hh:mm a')}</td>
                    <td className="text-right">
                      <MDButton size="small" color="primary" href={`/event/view/${event.guid}`} target="_blank">
                        View
                      </MDButton>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

          </>
          }

        </Modal.Body>
        <Modal.Footer>
          <MDButton color="primary" className={"mx-2"} onClick={() => {
            eventWarningCallback('continue')
          }}>
            Save anyways
          </MDButton>
          <MDButton color="info" onClick={() => {
            eventWarningCallback('cancel')
          }}>
            Cancel
          </MDButton>
        </Modal.Footer>
      </Modal>
    </>
  );
}